import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveAddressByBodyshop, GetAddressByBodyshop } from './index';

// Api's
import { addressApi } from '../../api';
import { AddressByBodyshopResponse } from '@/main/models/response';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getAddressByBodyshopSaga(action: GetAddressByBodyshop) {
  try {
    const response: AxiosResponse<Result<AddressByBodyshopResponse[]>> = yield call(
      addressApi.getAddressByBodyshop,
      action.payload.request
    );
    if (response.data.result) {
      yield put(saveAddressByBodyshop(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);
      
      yield put(saveAddressByBodyshop(null, true, resultError.messagesDataError));
    }
  }
}
